import { Component, OnInit, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { PoliticPartiesService } from '../../services/politic-parties.service';
import { QuestionsService } from '../../services/questions.service';

import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, BaseChartDirective, Label, MultiDataSet } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
	selector: 'app-results',
	templateUrl: './results.component.html',
	styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
	public barChartOptions: ChartOptions = {
		responsive: true,
		scales: { xAxes: [{}], yAxes: [{}] },

		plugins: {
			datalabels: {
				anchor: 'end',
				align: 'end',
				formatter: (value) => {
					return this.numberWithCommas(value)
				},
			}
		}
	};

	public barChartLabels: Label[] = [];
	public barChartType: ChartType = 'bar';
	public barChartLegend = true;
	public barChartPlugins = [pluginDataLabels];

	public barChartData: ChartDataSets[] = [
		{ data: [], label: 'Score', backgroundColor: "#fa4868", }
	];

	numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	}

	// Doughnut
	public directionChartLabels: Label[] = ['Links', 'Rechts'];
	public directionChartData: number[] = [0, 0];
	public directionChartType: ChartType = 'doughnut';
	public directionChartOptions: ChartOptions = {
		plugins: {
			datalabels: {
				formatter: (value) => {
					return this.numberWithCommas(value)
				},
			},
		}
	};
	public directionChartColors = [
		{
			backgroundColor: [
				'#e97687',
				'#a6d7f9'
			]
		}
	];

	// Doughnut
	public wingChartLabels: Label[] = ['Progressief', 'Conservatief'];
	public wingChartData: number[] = [0, 0];
	public wingChartType: ChartType = 'doughnut';
	public wingChartColors: Array<any> = [
		{
			backgroundColor: [
				'#7fd3b7',
				'#9a8fed'
			]
		}
	];

	public reactionScore;
	public reactionScorePercentage;
	public politicParty;
	public score;
	public total;
	public code;

	constructor(
		private renderer: Renderer2,
		private http: HttpClient,
		private router: Router,
		private politicPartiesService: PoliticPartiesService,
		private questionsService: QuestionsService,
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.setBGColor();

		this.code = (this.route.snapshot.paramMap.get('clientCode') != null) ? this.route.snapshot.paramMap.get('clientCode') : '';

		let element = this;

		this.http.get('https://jongerenstemtest.nl/api/results.php?code=' + encodeURIComponent(this.code))
			.subscribe(function (response) {

				if (response['found'] === false) {
					element.router.navigate(['/notFound']);
				}

				element.setParty(response['party']);
				element.setBarChartData(response);
				element.setWingDoughnut(response);
				element.setDirectionDoughnut(response);

				setTimeout(function () {
					element.reactionScore = response['reaction'];
					element.reactionScorePercentage = response['reactionPercentage'];
				}, 2000);

				element.total = response['total'];
				element.score = response['parties'][response['party']];
			});
	}

	setParty(party) {
		let politicalParties = this.politicPartiesService.getPoliticalParties();
		this.politicParty = politicalParties[party];
	}

	setBarChartData(response) {
		let barChartData = {};

		for (let key in this.politicPartiesService.getPoliticalParties()) {
			barChartData[key] = 0;
		}

		let element = this;
		element.barChartLabels = [];
		for (let key in response['parties']) {
			barChartData[key] = response['parties'][key];
		}

		element.barChartData[0].data = [];
		for (let key in barChartData) {
			let name = element.politicPartiesService.getPoliticalParties()[key]['name'];
			element.barChartLabels.push(name);
			element.barChartData[0].data.push(barChartData[key]);
		}
	}

	setWingDoughnut(response) {
		let element = this;
		element.wingChartLabels = ['Links', 'Rechts'];
		element.wingChartData = [response['wing']['left'], response['wing']['right']];
	}

	setDirectionDoughnut(response) {
		let element = this;
		element.directionChartLabels = ['Progressief', 'Conservatief'];
		element.directionChartData = [response['direction']['progressive'], response['direction']['conservative']];
	}

	ngOnDestroy() {
		this.setBGColor();
	}

	setBGColor() {
		let shuffleColors = ["#7E78B8", "#F06793", "#FCBA63", "#51BF9D", "#44C8F5"];
		let chooseRandomColor = Math.floor(Math.random() * shuffleColors.length);

		this.renderer.setStyle(document.body, 'background-color', shuffleColors[chooseRandomColor]);
	}
}
